export interface FeatureSection {
  title?: string;
  features: FeatureRow[];
}
export interface FeatureRow {
  feature: string;
  small: string;
  medium: string;
  large: string;
}
const baseFeatureSection: FeatureSection = {
  features: [
    {
      feature: "No. of connected devices/tills",
      small: "1 iPad",
      medium: "5 linked iPads",
      large: "25 linked iPads",
    },
    {
      feature: "No. of printer connections per iPad",
      small: "1 printer",
      medium: "10 printers",
      large: "10 printers",
    },
    {
      feature: "No. of pages on menu layout",
      small: "1 page",
      medium: "5 pages",
      large: "5 pages",
    },
    {
      feature: "No. of items",
      small: "40 live items",
      medium: "unlimited",
      large: "unlimited",
    },
    {
      feature: "No. of mods",
      small: "50 live mods",
      medium: "unlimited",
      large: "unlimited",
    },
  ],
};

const tillsAndBills: FeatureSection = {
  title: "Making tills & bills easy",
  features: [
    { feature: "Cash out", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Card & cash payments",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Customer tabs", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Customer + staff accounts",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Pre-paid gift vouchers",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Discounts", small: "✅", medium: "✅", large: "✅" },
    { feature: "Payment by item", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Split & partial payments",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Automatic surcharges",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Wastage management", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Hospo/comps management",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Quick gesture shortcuts (on till)",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Multiple dockets from any printer",
      small: "",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Duplicate docket printing",
      small: "",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Detailed order & transaction history",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Customisable order/docket notes",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Email receipts", small: "✅", medium: "✅", large: "✅" },
    { feature: "Integrated cash up", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Table service from iPads",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
  ],
};

const knowYourMargins: FeatureSection = {
  title: "Know your margins",
  features: [
    {
      feature: "Fully customisable menu",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Quickly duplicate menu items",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Multiple menus", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Item modifications & groups",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Recipe costings", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Stocktake management",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Stock invoices", small: "✅", medium: "✅", large: "✅" },
  ],
};
const understandYourNumbers: FeatureSection = {
  title: "Understand your numbers",
  features: [
    {
      feature: "Comprehensive live dashboard",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Sales reports", small: "✅", medium: "✅", large: "✅" },
    { feature: "Stock reports", small: "✅", medium: "✅", large: "✅" },
    { feature: "Custom reports", small: "✅", medium: "✅", large: "✅" },
    { feature: "Exportable reports", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Staff sales reports",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Wastage, refund & discount reports",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Ingredients moved reports",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Category reports", small: "✅", medium: "✅", large: "✅" },
    { feature: "Cash up reports", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Emailed weekly progress reports",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Did I Make Money Tool (cash flow)",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
  ],
};

const controlYourBusiness: FeatureSection = {
  title: "Control your business",
  features: [
    { feature: "Table layout", small: "✅", medium: "✅", large: "✅" },

    { feature: "Course management", small: "✅", medium: "✅", large: "✅" },
    { feature: "Table notes", small: "✅", medium: "✅", large: "✅" },
    { feature: "Covers", small: "✅", medium: "✅", large: "✅" },
    { feature: "Staff logins", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Controlled access to reporting",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Supplier order reminders",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
  ],
};

const nzIntegrations: FeatureSection = {
  title: "Integrations/extend your business",
  features: [
    { feature: "Xero integrations", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Mobile Ordering (Regulr)",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    { feature: "Verifone Eftpos", small: "✅", medium: "✅", large: "✅" },
    { feature: "Smartpay Eftpos", small: "✅", medium: "✅", large: "✅" },
    { feature: "Windcave Eftpos", small: "✅", medium: "✅", large: "✅" },
    { feature: "BNZ Payclip (NZ)", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "QR ordering",
      small: "coming soon",
      medium: "coming soon",
      large: "coming soon",
    },
  ],
};

const auIntegrations: FeatureSection = {
  title: "Integrations/extend your business",
  features: [
    { feature: "Xero integrations", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Mobile Ordering (Regulr)",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Zellar",
      small: "coming soon",
      medium: "coming soon",
      large: "coming soon",
    },
    { feature: "Smartpay Eftpos", small: "✅", medium: "✅", large: "✅" },
    { feature: "Windcave Eftpos", small: "✅", medium: "✅", large: "✅" },
    { feature: "Tryo", small: "✅", medium: "✅", large: "✅" },
    { feature: "Square Payments", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "QR ordering",
      small: "coming soon",
      medium: "coming soon",
      large: "coming soon",
    },
  ],
};

const ukIntegrations: FeatureSection = {
  title: "Integrations/extend your business",
  features: [
    {
      feature: "Mobile Ordering (Regulr)",
      small: "coming soon",
      medium: "coming soon",
      large: "coming soon",
    },
    { feature: "Windcave Eftpos", small: "✅", medium: "✅", large: "✅" },
    { feature: "Tryo", small: "✅", medium: "✅", large: "✅" },
    { feature: "Square Payments", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Stripe Terminal",
      small: "coming soon",
      medium: "coming soon",
      large: "coming soon",
    },
    {
      feature: "QR ordering",
      small: "coming soon",
      medium: "coming soon",
      large: "coming soon",
    },
  ],
};

const support: FeatureSection = {
  title: "Feel supported",
  features: [
    { feature: "Knowledge base", small: "✅", medium: "✅", large: "✅" },
    {
      feature: "Fast & friendly online support",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Set-up guides + walkthroughs",
      small: "✅",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "45min video training",
      small: "",
      medium: "✅",
      large: "✅",
    },
    {
      feature: "Phone Support",
      small: "",
      medium: "coming soon",
      large: "coming soon",
    },
  ],
};
export interface AddOnFeatureRow {
  feature: string;
  sogui: string;
  regulr: string;
  paperless: string;
}

export interface AddOnSection {
  title: string;
  features: AddOnFeatureRow[];
}

const nzPaperlessAddOnFeatures: AddOnFeatureRow[] = [
  {
    feature: "Display screen for orders (up to 5)",
    sogui: "",
    regulr: "",
    paperless: "✅",
  },
  {
    feature: "Average order preparation time",
    sogui: "",
    regulr: "",
    paperless: "✅",
  },
  {
    feature: "Average order serving time",
    sogui: "",
    regulr: "",
    paperless: "✅",
  },
  { feature: "Preparing screen", sogui: "", regulr: "", paperless: "✅" },
];
const nzMobileOrderingAddOnFeatures: AddOnFeatureRow[] = [
  {
    feature: "Weekly online tab payment",
    sogui: "",
    regulr: "",
    paperless: "✅",
  },
  { feature: "Serving screen", sogui: "", regulr: "", paperless: "✅" },
  { feature: "Online menus", sogui: "✅", regulr: "✅", paperless: "" },
  {
    feature: "Online menu promotions",
    sogui: "✅",
    regulr: "",
    paperless: "",
  },
  {
    feature: "Bill payments at table (QR)",
    sogui: "✅",
    regulr: "",
    paperless: "",
  },
  { feature: "Mobile ordering", sogui: "", regulr: "", paperless: "✅" },
  {
    feature: "Weekly online tab payment",
    sogui: "",
    regulr: "",
    paperless: "✅",
  },
];
const NZAddOnSections: AddOnSection[] = [
  { title: "Paper free digital orders", features: nzPaperlessAddOnFeatures },
  {
    title: "Get your menu seen online",
    features: nzMobileOrderingAddOnFeatures,
  },
];
export interface CountryPlans {
  featureSections: FeatureSection[];
  addonSections: AddOnSection[];
  small: string;
  medium: string;
  large: string;
  sogui: string;
  regulr: string;
  paperless: string;
}
export const nzFeatures: FeatureSection[] = [
  baseFeatureSection,
  tillsAndBills,
  knowYourMargins,
  understandYourNumbers,
  controlYourBusiness,
  nzIntegrations,
  support,
];
export const tongaFeatures: FeatureSection[] = [
  baseFeatureSection,
  tillsAndBills,
  knowYourMargins,
  understandYourNumbers,
  controlYourBusiness,
  support,
];

export const auFeatures: FeatureSection[] = [
  baseFeatureSection,
  tillsAndBills,
  knowYourMargins,
  understandYourNumbers,
  controlYourBusiness,
  auIntegrations,
  support,
];

const ukFeatures: FeatureSection[] = [
  baseFeatureSection,
  tillsAndBills,
  knowYourMargins,
  understandYourNumbers,
  controlYourBusiness,
  ukIntegrations,
  support,
];

export const tongaPlans: CountryPlans = {
  featureSections: tongaFeatures,
  addonSections: NZAddOnSections,
  small: "Small - $59",
  medium: "Medium - $88",
  large: "Large - $180",
  sogui: "SOGUI - Free",
  regulr: "Regulr - $39",
  paperless: "Paperless - $39",
};
export const nzPlans: CountryPlans = {
  featureSections: nzFeatures,
  addonSections: NZAddOnSections,
  small: "Small - $59",
  medium: "Medium - $88",
  large: "Large - $180",
  sogui: "SOGUI - Free",
  regulr: "Regulr - $39",
  paperless: "Paperless - $39",
};
export const auPlans: CountryPlans = {
  featureSections: auFeatures,
  addonSections: NZAddOnSections,
  small: "Small - $59",
  medium: "Medium - $88",
  large: "Large - $180",
  sogui: "SOGUI - Free",
  regulr: "Regulr - $39",
  paperless: "Paperless - $39",
};

export const ukPlans: CountryPlans = {
  featureSections: ukFeatures,
  addonSections: NZAddOnSections,
  small: "Small - £59",
  medium: "Medium - £88",
  large: "Large - £180",
  sogui: "SOGUI - Free",
  regulr: "Regulr - £39",
  paperless: "Paperless - £39",
};
